import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ae2a3bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-align-center gap-x-5" }
const _hoisted_2 = { class: "cm-align-center gap-x-5" }

import { reactive, ref, watch, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { TableOptColumn } from '@/components/cmTable/types'
import { DeviceStatus } from '@/views/dashboard/safe-status/device-status/device-status.service'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import { FlowService } from './service'
import StatisticsCards from './_components/statistics-cards.vue'
import TrafficTrendChart from './_components/traffic-trend-chart.vue'
import TrafficRankingChart from './_components/traffic-ranking-chart.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { PolicyCommonService, StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'
import { GroupRefreshManage } from '@/services/group'
import TaskTimeShow from '@/views/dashboard/_components/task-time/task-time-show.vue'
import { getUnionLabelMap } from '../traffic-control/traffic-control-i18n-labels'
import StrategySetting from '../traffic-control/components/strategy-setting.vue'
import TrafficStatusList from '../../port-manage/_components/traffic-status-list/traffic-status-list.vue'
import type { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import TrafficDetailDrawer from '@/views/dashboard/_components/traffic-detail-drawer/traffic-detail-drawer.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import { getTimeRangeByEnum } from '@/utils/time'
import { TimeRange, TimeGranularity } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n()
const unionLabel = getUnionLabelMap()

const injector = useReflectiveInjector([FlowService, PolicyCommonService, GroupRefreshManage])
const flowService = injector.get(FlowService)
const policyCommonService = injector.get(PolicyCommonService)
const servicePermissionService = injector.get(ServicePermissionService)
const groupRefreshManage = injector.get(GroupRefreshManage)
const saveOrUpdateApi = policyCommonService.saveSettings.bind(policyCommonService)
const getApi = policyCommonService.getSettings.bind(policyCommonService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.flow_monitor)

const visible = ref(false)
const detailVisible = ref(false)
const detailDevice = ref<{ device_id: string; computer_name?: string } | null>(null)

// 统计数据
const statistics = reactive({
  todayUploadTraffic: '0',
  todayDownloadTraffic: '0',
  effectivePolicies: 0
})

// 图表数据
const trendChartData = ref<{
  times: string[]
  upload: number[]
  download: number[]
}>({
  times: [],
  upload: [],
  download: []
})

/** 趋势图时间范围（与排行图独立，互不影响） */
const trendTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const rankingTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const rankingData = ref<Array<{ name: string; department: string; count: number }>>([])

// 策略相关
const policyManageRef = ref()
const activeRow = ref({} as StrategyListDataCommon)
const fromGroupId = ref()
const selectedPolicyIds = ref([])

const customCols = computed<TableOptColumn[]>(() => [
  { label: t('terminalTrafficStateList.maxUploadSpeed'), prop: 'up_speed' },
  { label: t('terminalTrafficStateList.maxDownloadSpeed'), prop: 'down_speed' },
  { label: t('terminalTrafficStateList.executeTime'), prop: 'frequency' }
])

const trafficStatusListRef = ref()
const trafficDrawerVisible = ref(false)
const trafficDrawerEmbed = ref<{ key_word?: string; start_time?: string; end_time?: string } | null>(null)
const trafficRankingChartRef = ref()

function viewAllTraffic() {
  if (!hasPermission) return
  trafficDrawerEmbed.value = null
  trafficDrawerVisible.value = true
}

/** 排行图行点击：与当前排行时间范围一致，关键词为计算机名，侧栏打开流量列表 */
function handleRankingItemClick(item: RankingItem & { computer_name?: string; name?: string }) {
  const [st, et] = getTimeRangeByEnum(rankingTimeRange.value)
  const name = (item.computer_name || item.name || '').trim()
  trafficDrawerEmbed.value = {
    key_word: name || undefined,
    start_time: st != null ? String(st) : undefined,
    end_time: et != null ? String(et) : undefined,
  }
  trafficDrawerVisible.value = true
}

// 处理流量详情点击
function handleTrafficDetail(rowItem: DeviceStatus) {
  detailDevice.value = { device_id: rowItem.device_id, computer_name: rowItem.computer_name }
  detailVisible.value = true
}

// 加载统计数据
async function loadStatistics() {
  if (!hasPermission) return

  try {
    const now = Math.floor(dayjs().valueOf() / 1000)
    const startTime = Math.floor(dayjs().startOf('day').valueOf() / 1000)

    const res = await flowService.getSafemonitorFlowOverviewStat({
      start_time: startTime.toString(),
      end_time: now.toString()
    })

    statistics.todayUploadTraffic = res.today_upload_flow || 0
    statistics.todayDownloadTraffic = res.today_download_flow || 0
    statistics.effectivePolicies = res.active_policy_count || 0
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

function formatTrendAxisTime (timestampSec: string, range: TimeRange): string {
  const ms = Number(timestampSec) * 1000
  if (range === TimeRange.HOURS_24) {
    return dayjs(ms).format('HH:mm')
  }
  return dayjs(ms).format('MM-DD')
}

/** 流量字符串 / 数字：有 GB/MB 等后缀则按单位解析；纯数字按「字节」（与接口 total_flow 一致） */
function parseFlowMatch(raw: unknown): { value: number; unit: string } | null {
  if (raw == null || raw === '') return null
  const flowStr = String(raw).trim()
  if (!flowStr) return null
  const match = flowStr.match(/^([\d.]+)\s*(GB|MB|TB|KB|B)?$/i)
  if (!match) return null
  const value = parseFloat(match[1])
  if (!Number.isFinite(value)) return null
  return { value, unit: (match[2] || '').toUpperCase() }
}

/** 流量字符串 / 数字：解析为字节（排行图进度条与 bytesToSize 展示） */
function parseTotalFlowToBytes(raw: unknown): number {
  const m = parseFlowMatch(raw)
  if (!m) return 0
  const { value, unit } = m
  if (!unit) return value
  switch (unit) {
    case 'TB':
      return value * 1024 ** 4
    case 'GB':
      return value * 1024 ** 3
    case 'MB':
      return value * 1024 ** 2
    case 'KB':
      return value * 1024
    case 'B':
      return value
    default:
      return value
  }
}

/** 流量字符串 / 数字：有 GB/MB 等后缀则按单位解析；纯数字按「字节」转 GB（与趋势图 Y 轴 GB 一致） */
function parseTotalFlowToGb(raw: unknown): number {
  const bytes = parseTotalFlowToBytes(raw)
  return bytes / (1024 * 1024 * 1024)
}

// 加载趋势图表数据（仅受 trendTimeRange 影响）
async function loadTrendData() {
  if (!hasPermission) return

  try {
    const [start_time, end_time] = getTimeRangeByEnum(trendTimeRange.value)
    if (start_time === undefined || end_time === undefined) {
      trendChartData.value = { times: [], upload: [], download: [] }
      return
    }

    const granularity = TimeGranularity[trendTimeRange.value] || 'hour'
    const res = await flowService.getSafemonitorFlowTrendStat({
      start_time: start_time.toString(),
      end_time: end_time.toString(),
      granularity
    })

    trendChartData.value = {
      times: (res.time_points || []).map(ts => formatTrendAxisTime(String(ts), trendTimeRange.value)),
      upload: (res.upload_flow_list || []).map(v => parseTotalFlowToGb(v)),
      download: (res.download_flow_list || []).map(v => parseTotalFlowToGb(v))
    }
  } catch (error) {
    console.error('加载趋势图表数据失败:', error)
    trendChartData.value = {
      times: [],
      upload: [],
      download: []
    }
  }
}

// 加载排行图表数据
async function loadRankingData() {
  if (!hasPermission) return

  if (trafficRankingChartRef.value) {
    trafficRankingChartRef.value.loading = true
  }
  try {
    const [start_time, end_time] = getTimeRangeByEnum(rankingTimeRange.value)

    if (start_time === undefined || end_time === undefined) {
      rankingData.value = []
      return
    }

    const res = await flowService.getSafemonitorFlowTopTerminalStat({
      start_time: start_time.toString(),
      end_time: end_time.toString(),
      top_count: 5
    })

    rankingData.value = (res.top_terminal_list || []).map(item => ({
      name: item.computer_name || t('terminalTrafficStateList.unknown'),
      computer_name: item.computer_name || '',
      department: item.department || t('overviewZone.ungrouped'),
      count: parseTotalFlowToBytes(item.total_flow),
    }))
  } catch (error) {
    console.error('加载排行数据失败:', error)
    rankingData.value = []
  } finally {
    if (trafficRankingChartRef.value) {
      trafficRankingChartRef.value.loading = false
    }
  }
}

// 策略相关处理函数
const handlePolicyAction = ({ type, ...other }: { type: string;[type: string]: any; }) => {
  const types: any = {
    add: () => {
      visible.value = true
      activeRow.value = {} as StrategyListDataCommon
      fromGroupId.value = undefined
    },
    edit: async () => {
      visible.value = true
      activeRow.value = other.rowItem
      fromGroupId.value = undefined
    },
  }
  types?.[type]?.()
}

const handlePolicySelected = (selection = [], ids = []) => {
  selectedPolicyIds.value = ids
}

function handleRefresh() {
  groupRefreshManage.refreshGroup()
  policyManageRef.value.tableRef.getList()
}

const getPrefixActButtons = () => []

watch(trendTimeRange, () => {
  loadTrendData()
})

watch(rankingTimeRange, () => {
  loadRankingData()
})

// 初始化加载数据
onMounted(async () => {
  if (hasPermission) {
    await Promise.all([
      loadStatistics(),
      loadTrendData(),
      loadRankingData()
    ])
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageSubscribeBar, {
      "normal-permission-key": _unref(PermissionFe).flow_monitor
    }, null, 8, ["normal-permission-key"]),
    _createVNode(StatisticsCards, {
      "today-upload-traffic": statistics.todayUploadTraffic,
      "today-download-traffic": statistics.todayDownloadTraffic,
      "effective-policies": statistics.effectivePolicies
    }, null, 8, ["today-upload-traffic", "today-download-traffic", "effective-policies"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      style: {"height":"360px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 18 }, {
          default: _withCtx(() => [
            _createVNode(TrafficTrendChart, {
              "time-range": trendTimeRange.value,
              "onUpdate:timeRange": _cache[0] || (_cache[0] = ($event: any) => ((trendTimeRange).value = $event)),
              data: trendChartData.value
            }, null, 8, ["time-range", "data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(TrafficRankingChart, {
              ref_key: "trafficRankingChartRef",
              ref: trafficRankingChartRef,
              "time-range": rankingTimeRange.value,
              "onUpdate:timeRange": _cache[1] || (_cache[1] = ($event: any) => ((rankingTimeRange).value = $event)),
              data: rankingData.value,
              onItemClick: handleRankingItemClick
            }, null, 8, ["time-range", "data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('terminalTrafficStateList.trafficTop10Title'),
      class: "cm-ui-mt16 cm-ui-mb16"
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(TrafficStatusList, {
          ref_key: "trafficStatusListRef",
          ref: trafficStatusListRef,
          onDetail: handleTrafficDetail,
          onViewAll: viewAllTraffic
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(PolicyManage, {
      title: _ctx.$t('terminalTrafficStateList.policyList'),
      ref_key: "policyManageRef",
      ref: policyManageRef,
      "normal-permission-key": _unref(PermissionFe).flow_monitor,
      triggerTime: "none",
      prefixActButtons: getPrefixActButtons,
      "strategy-type": _unref(PolicyType).terminal_flow_monitor,
      "custom-cols": customCols.value,
      "data-type": _unref(PolicySettingType).terminal_flow_monitor,
      "show-group-selector": true,
      "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
      onHandleAction: handlePolicyAction,
      onChangeSelected: handlePolicySelected
    }, {
      table__frequency: _withCtx(({ row }: { row: { strategy: { frequency: number; regular_tasks: any } } }) => [
        _createVNode(TaskTimeShow, {
          frequency: row.strategy.frequency,
          "task-time": row.strategy.regular_tasks
        }, null, 8, ["frequency", "task-time"])
      ]),
      table__up_speed: _withCtx(({ row }: { row: { strategy: { up_speed: string; up_unit: number } } }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/manage/terminal-traffic-control/terminal-traffic-state-list/images/7",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(row.strategy.up_speed) + _toDisplayString(_unref(unionLabel)[row.strategy.up_unit]), 1)
        ])
      ]),
      table__down_speed: _withCtx(({ row }: { row: { strategy: { down_speed: string; down_unit: number } } }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/manage/terminal-traffic-control/terminal-traffic-state-list/images/6",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(row.strategy.down_speed) + _toDisplayString(_unref(unionLabel)[row.strategy.down_unit]), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "normal-permission-key", "strategy-type", "custom-cols", "data-type", "terminal-type"]),
    _createVNode(_component_el_drawer, {
      size: "75%",
      title: _ctx.$t('terminalTrafficStateList.strategySetting'),
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(StrategySetting, {
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
          onRefresh: handleRefresh,
          hasPermission: _unref(hasPermission),
          api: { getApi: _unref(getApi), saveOrUpdateApi: _unref(saveOrUpdateApi) },
          id: activeRow.value.id,
          "from-group-id": fromGroupId.value
        }, null, 8, ["modelValue", "hasPermission", "api", "id", "from-group-id"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('terminalTrafficStateList.allTrafficStateTitle'),
      modelValue: trafficDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((trafficDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(TrafficStatusList, {
          viewMode: _unref(TableViewMode).full,
          style: {"padding":"10px 16px"},
          "embed-defaults": trafficDrawerEmbed.value,
          onDetail: handleTrafficDetail
        }, null, 8, ["viewMode", "embed-defaults"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(TrafficDetailDrawer, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((detailVisible).value = $event)),
      device: detailDevice.value
    }, null, 8, ["modelValue", "device"])
  ], 64))
}
}

})